import type { TRuleWithTheme } from '@/styles/theme';

// Escapes the sidebar's 1.5rem padding to an ~8px gutter, like MenuItem.
export const row: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(8),
    width: 'calc(100% + 2rem)',
    height: '32px',
    marginRight: '-1rem',
    marginLeft: '-1rem',
    padding: `0 ${theme.spacing(12)}`,
    border: 'none',
    borderRadius: theme.spacing(8),
    backgroundColor: 'transparent',
    cursor: 'pointer',
    ...theme.typography.ParagraphSmallMedium,
    color: theme.colors.foregroundsPrimary,
    transition: 'background-color 0.15s ease',

    ':hover': {
        backgroundColor: theme.colors.listItemHoverBg,
    },
});

export const flag: TRuleWithTheme = () => ({
    flexShrink: 0,
    width: 15,
    height: 10,
});

export const label: TRuleWithTheme = () => ({
    flex: 1,
    minWidth: 0,
    textAlign: 'left',
});

export const currentLanguage: TRuleWithTheme = ({ theme }) => ({
    flexShrink: 0,
    ...theme.typography.ParagraphExtraSmallMedium,
});

export const chevron: TRuleWithTheme = ({ theme }) => ({
    flexShrink: 0,
    color: theme.colors.iconsPrimary,
});
